import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-component',
  standalone: false,
  templateUrl: './input-component.html',
  styleUrls: ['./input-component.css'] // ✅ fixed typo (should be styleUrls)
})
export class InputComponent {
  // Input type: text, email, password, number, date, phone, etc.
  @Input() type:
    | 'text'
    | 'email'
    | 'password'
    | 'number'
    | 'date'
    | 'datetime-local'
    | 'tel' = 'text';

  // Label text
  @Input() label = '';
  // Placeholder text
  @Input() placeholder = '';
  // ngModel value
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  // Optional prefix icon (Font Awesome or Keen)
  @Input() icon?: string;
  // Optional input prefix text (e.g., @ or +47)
  @Input() prefixText?: string;
  // Input size: sm | lg | default
  @Input() size: 'sm' | 'lg' | '' = '';
  // Optional validation states
  @Input() valid = false;
  @Input() invalid = false;

  // Floating label toggle
  @Input() floating = true;

  // Disabled state
  @Input() disabled = false;

  // Emit value changes
  onInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.valueChange.emit(this.value);
  }
}
